import axiosInstance from "../axiosClient";

export const signupUser = async (signupDetails) => {
  try {
    const response = await axiosInstance.post(`/auth/signup`, signupDetails);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (passwordDetails) => {
  try {
    const response = await axiosInstance.post(
      `/auth/reset-password`,
      passwordDetails
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyExpirationToken = async (token) => {
  try {
    const response = await axiosInstance.get(`/auth/check_token/${token}`,token);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkTokenStatus = async (token) => {
  try {
    const response = await axiosInstance.get(`/auth/check_token/${token}`);
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }
    return response.data.isValidToken;
  } catch (error) {
    throw error;
  }
};

export const verifyEmail = async (id) => {
  try {
    const response = await axiosInstance.post(`/auth/verify_email/${id}`, {
      emailVerified: true,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const resendEmail = async (email, id) => {
  try {
    const payload = { email, id };
    const response = await axiosInstance.post("/auth/resend_email", payload);
    return response;
  } catch (error) {
    throw error;
  }
};
